import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './index.css';
import App from './App';
import BlogPost from './BlogPost';
import About from './About';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <Router>
      <Routes>
        {/* Home page - shows blog grid */}
        <Route path="/" element={<App />} />
        
        {/* Individual blog post pages */}
        <Route path="/post/:slug" element={<BlogPost />} />
        
        {/* About page */}
        <Route path="/about" element={<About />} />
      </Routes>
    </Router>
  </React.StrictMode>
);